import * as Axios from 'axios';
import BaseService from '../common/BaseService';
import store from '@/store';
import { IUser } from '@/domain/common';

export default class BankWatchUserService extends BaseService {
    public async getAllUsers(): Promise<IUser[]> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/bankwatch/users/`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig)
        return res.data as IUser[];
    }

    public async deactivateUser(userId: string): Promise<void> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'delete',
            url: `${store.state.apiBase}/bankwatch/users/${userId}`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        await this.makeAxiosCall(apiConfig);
    }

    public async saveUser(userId: string, user: IUser): Promise<void> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'put',
            url: `${store.state.apiBase}/bankwatch/users/update/${userId}`,
            data: {
                user
            },
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig)
        return res.data;
    }
}
